import React from 'react'
import { ProductVideo } from '@components/category/ProductImageGallery/ProductVideo'
import { ProductImageGalleryVideoThumbnail } from '@components/category/ProductImageGallery/ProductImageGalleryVideoThumbnail'
import { getVideoFrameDataUrl } from '@utils/video'
import { ContentfulNextJsImage } from '@components/common/ContentfulImage'
import { IImage } from '@utils/contentful/contentfulImage'
import { IImageGalleryRef } from '@components/category/ProductImageGallery/ProductImageGallery'
export function getImageUrl({
  image,
  imageBackgroundColour,
  priority = false,
}: {
  image: IImage
  imageBackgroundColour: string
  priority?: boolean
}) {
  const src = image?.imageUrl
  const alt = image?.imageTitle

  return {
    renderItem: () => (
      <ContentfulNextJsImage
        src={src}
        alt={alt}
        fill={true}
        format="jpg"
        backgroundColour={imageBackgroundColour}
        quality={60}
        objectFit="contain"
        className="lg:!py-[56px]"
        sizes="(max-width: 1024px) 70vw, 100vw"
        priority={priority}
      />
    ),
    renderThumbInner: () => {
      return (
        <ContentfulNextJsImage
          src={src}
          alt={alt}
          height={56}
          width={56}
          format="jpg"
          backgroundColour={imageBackgroundColour}
          quality={70}
          className="rounded-[6px]"
          priority={priority}
        />
      )
    },
    thumbnail: src,
  }
}

export const processProductAssetsFromContentful = async ({
  image,
  imageBackgroundColour,
  imageIndex,
  autoPlay = false,
  galleryRef,
}: {
  image: IImage
  imageBackgroundColour: string
  imageIndex: number
  autoPlay: boolean
  galleryRef: React.RefObject<IImageGalleryRef>
}) => {
  const src = image?.imageUrl
  const imageTitle = image?.imageTitle
  const bulletClass = `w-12 sm:w-16 !p-0 !rounded-none ${
    autoPlay ? 'autoplay' : ''
  }`

  if (src?.startsWith('//images.ctfassets.net/')) {
    return {
      ...getImageUrl({
        image,
        imageBackgroundColour,
        priority: imageIndex === 0,
      }),
      bulletClass: `${bulletClass} image-slide`,
    }
  } else if (src?.startsWith('//videos.ctfassets.net/')) {
    let imageDataUrl = ''
    try {
      imageDataUrl = await getVideoFrameDataUrl(src)
    } catch {
      imageDataUrl = ''
    }

    return {
      renderItem: () => (
        <ProductVideo src={src} title={imageTitle} galleryRef={galleryRef} />
      ),
      renderThumbInner: () => {
        return (
          <ProductImageGalleryVideoThumbnail
            src={imageDataUrl}
            title={imageTitle}
          />
        )
      },
      thumbnail: imageDataUrl,
      srcSet: src,
      bulletClass: `${bulletClass} video-slide`,
    }
  } else {
    return {
      original: src,
      thumbnail: src + '?w=150',
      srcSet: src,
      bulletClass,
    }
  }
}
